import createRoot, { contextPlugin, configPlugin, nodeNamePlugin, parentPlugin, } from '@getgo/arborist';
import loggerPlugin from './plugins/logger';
import loggerErrorHandlerPlugin from './plugins/logger_error_handler';
import consoleTargetPlugin from './plugins/logger_target_console';
import loggerWhenPlugin from './plugins/logger_when';
export { setup as globalErrorHandlerSetup } from './inputs/global_error_handler';
export default createRoot([
    parentPlugin,
    nodeNamePlugin,
    contextPlugin,
    configPlugin,
    loggerPlugin,
    loggerWhenPlugin,
    loggerErrorHandlerPlugin,
    consoleTargetPlugin,
]);
//# sourceMappingURL=index.js.map